import React from 'react';

export const MethodSection = ({ t }) => {
  return (
    <section id="method" className="section-padding section-white border-t border-gray-300 relative">
      {/* Structural axis on right */}
      <div className="absolute right-0 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-gray-200 to-transparent" />
      
      <div className="container mx-auto px-8 max-w-7xl">
        <div className="mb-28">
          <p className="text-xs text-gray-400 uppercase tracking-widest mb-8 font-light">{t.method.label}</p>
          <h2 className="text-6xl md:text-8xl font-normal text-gray-900 mb-10 tracking-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            {t.method.title}
          </h2>
          <div className="w-24 h-px bg-gray-300" />
        </div>

        <div className="space-y-24">
          {t.method.steps.map((step, index) => (
            <div 
              key={index}
              className="grid md:grid-cols-12 gap-12 items-start relative pb-24 border-b border-gray-200 last:border-0"
            >
              {/* Number with structural element */}
              <div className="md:col-span-3 relative">
                <div className="absolute left-0 top-0 w-px h-full bg-gray-200" />
                <div className="pl-8">
                  <span className="text-7xl font-light text-gray-200 block mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                    {step.number}
                  </span>
                </div>
              </div>
              
              {/* Content - asymmetric */}
              <div className="md:col-span-9">
                <h3 className="text-4xl font-normal text-gray-900 mb-8 leading-tight tracking-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  {step.title}
                </h3>
                <p className="text-xl text-gray-600 font-light leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
